import get from 'lodash/get';
import { optionStatus } from '@/data/optionStatus';

const payment = {
    'CB': 'Paiement en CB',
    'PRELEV': 'Prélèvement Bancaire',
};

function formatPaymentMethod(value: string) {
    return get(payment, value, value);
}


export { payment, formatPaymentMethod };
